import type { EntityMetadata } from 'types';

export const PREFER_ORIGINAL_ALL_LANGUAGES = '*';

export type UserMetadataData = {
  showHighlights?: boolean;
  preferOriginalLanguages?: string[];
};

export const getUserMetadataData = (
  metadata: EntityMetadata | null | undefined
): UserMetadataData => {
  if (!metadata?.data || typeof metadata.data !== 'object') {
    return {};
  }
  return metadata.data as UserMetadataData;
};

const emptyPreferOriginalLanguages: string[] = [];

export const getPreferOriginalLanguages = (data: UserMetadataData): string[] => {
  const languages = data.preferOriginalLanguages;
  if (!Array.isArray(languages)) {
    return emptyPreferOriginalLanguages;
  }
  const normalized = languages.filter(
    (lang): lang is string => typeof lang === 'string' && Boolean(lang)
  );
  return normalized.length === languages.length ? languages : normalized;
};

export const getLikelyLanguage = (
  communication: { meta_data?: object | null } | null | undefined
): string | undefined => {
  if (!communication?.meta_data || typeof communication.meta_data !== 'object') {
    return undefined;
  }
  const language = (communication.meta_data as { likely_language?: unknown }).likely_language;
  return typeof language === 'string' ? language : undefined;
};

export const shouldPreferOriginal = (
  preferOriginalLanguages: string[],
  likelyLanguage: string | undefined
): boolean => {
  if (preferOriginalLanguages.includes(PREFER_ORIGINAL_ALL_LANGUAGES)) {
    return true;
  }
  return Boolean(likelyLanguage && preferOriginalLanguages.includes(likelyLanguage));
};
